import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
// Sleek icons from react-icons
import { FaWhatsapp } from 'react-icons/fa';
import { FiMail, FiMapPin, FiCheckCircle } from 'react-icons/fi';
import { MdChevronRight } from 'react-icons/md';

// Importing theme from constants path
import { THEME } from '../../utils/constants';

export default function ContactUs() {
    const [hoveredCard, setHoveredCard] = useState(null);

    const customColors = {
        cardBg: '#0d213a'
    };

    // WhatsApp click handler redirection string
    const handleWhatsAppRedirect = () => {
        const phoneNumber = '+91-9370806369'; // Replace with your operational business WhatsApp number
        const baselineText = `Hello Rasops Team, I would like to get details about your custom QR ordering systems and payment gateway integrations. Please connect with me.`;
        const encodedText = encodeURIComponent(baselineText);
        window.open(`https://api.whatsapp.com/send/?phone=${phoneNumber}&text=${encodedText}`, '_blank');
    };

    return (
        <div
            className='position-relative py-5 min-vh-screen d-flex align-items-center'
            style={{ backgroundColor: THEME.colors.secondary, color: THEME.colors.white, overflow: 'hidden' }}
        >
            {/* Background Ambient Glow Accent */}
            <div
                className='position-absolute rounded-circle pointer-events-none'
                style={{
                    top: '10%',
                    left: '20%',
                    width: '600px',
                    height: '600px',
                    background: `radial-gradient(circle, ${THEME.colors.primary}12 0%, transparent 70%)`,
                    filter: 'blur(80px)',
                    zIndex: 1
                }}
            />

            <Container className='position-relative py-5' style={{ zIndex: 2 }}>

                {/* Header Block */}
                <div className='text-center mx-auto mb-5 pb-3' style={{ maxWidth: '750px' }}>
                    <h1 className='display-4 font-weight-bold mt-4 tracking-tight' style={{ color: THEME.colors.white }}>
                        Let’s scale your restaurant <br />
                        <span style={{ color: THEME.colors.white, opacity: 0.9 }}>operations together.</span>
                    </h1>

                    <p className='lead mt-3' style={{ fontSize: '1.1rem', fontWeight: '300', color: THEME.colors.gray }}>
                        Have questions about specialized features, high-performance systems, or enterprise scaling? Reach out instantly.
                    </p>
                </div>

                <Row className='g-5 align-items-stretch mt-2'>

                    {/* Left Column: Why connect with Rasops Value Propositions */}
                    <Col lg={6} className='pe-lg-4 d-flex'>
                        <Card
                            className='border-0 p-4 shadow-lg rounded-4 w-100'
                            style={{ backgroundColor: customColors.cardBg, border: '1px solid rgba(255,255,255,0.05)' }}
                        >
                            <Card.Body className='d-flex flex-column justify-content-center'>
                                <h3 className='mb-4 pb-2' style={{ fontWeight: '600', color: THEME.colors.white }}>Why connect with Rasops?</h3>
                                <div className='d-flex flex-column gap-4'>

                                    <div className='d-flex align-items-start gap-3'>
                                        <FiCheckCircle className='mt-1 flex-shrink-0' style={{ color: THEME.colors.primary, fontSize: '1.25rem' }} />
                                        <div>
                                            <span className='d-block text-white font-weight-medium' style={{ fontSize: '1rem', lineHeight: '1.5' }}>
                                                Custom pricing tailored for scaling restaurant chains.
                                            </span>
                                        </div>
                                    </div>

                                    <div className='d-flex align-items-start gap-3'>
                                        <FiCheckCircle className='mt-1 flex-shrink-0' style={{ color: THEME.colors.primary, fontSize: '1.25rem' }} />
                                        <div>
                                            <span className='d-block text-white font-weight-medium' style={{ fontSize: '1rem', lineHeight: '1.5' }}>
                                                Customization as per the hotel theme and requirement.
                                            </span>
                                        </div>
                                    </div>

                                    <div className='d-flex align-items-start gap-3'>
                                        <FiCheckCircle className='mt-1 flex-shrink-0' style={{ color: THEME.colors.primary, fontSize: '1.25rem' }} />
                                        <div>
                                            <span className='d-block text-white font-weight-medium' style={{ fontSize: '1rem', lineHeight: '1.5' }}>
                                                Best QR ordering system with different UX layouts and more customization available with integrated payment gateways at lowest rates.
                                            </span>
                                        </div>
                                    </div>

                                    <div className='d-flex align-items-start gap-3'>
                                        <FiCheckCircle className='mt-1 flex-shrink-0' style={{ color: THEME.colors.primary, fontSize: '1.25rem' }} />
                                        <div>
                                            <span className='d-block text-white font-weight-medium' style={{ fontSize: '1rem', lineHeight: '1.5' }}>
                                                Increase sales by connecting your customers more deeply with Rasops.
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Right Column: Direct Instant Action Cards */}
                    <Col lg={6} className='d-flex flex-column justify-content-between gap-4'>

                        {/* WhatsApp Connection Card */}
                        <div
                            onClick={handleWhatsAppRedirect}
                            className='d-flex align-items-center gap-4 p-4 rounded-4 flex-grow-1'
                            onMouseEnter={() => setHoveredCard('whatsapp')}
                            onMouseLeave={() => setHoveredCard(null)}
                            style={{
                                backgroundColor: hoveredCard === 'whatsapp' ? customColors.cardBg : `${customColors.cardBg}90`,
                                border: hoveredCard === 'whatsapp' ? `1px solid ${THEME.colors.primary}60` : '1px solid rgba(255,255,255,0.05)',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer'
                            }}
                        >
                            <div
                                className='p-4 rounded-3 d-flex align-items-center justify-content-center shadow'
                                style={{
                                    backgroundColor: hoveredCard === 'whatsapp' ? THEME.colors.primary : `${THEME.colors.primary}12`,
                                    color: hoveredCard === 'whatsapp' ? THEME.colors.secondary : THEME.colors.primary,
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <FaWhatsapp size={28} />
                            </div>
                            <div className='flex-grow-1'>
                                <small className='text-uppercase tracking-wider d-block font-weight-bold' style={{ fontSize: '0.75rem', letterSpacing: '1.5px', color: THEME.colors.textMuted }}>Instant Chat</small>
                                <h4 className='font-weight-bold text-white mb-1 mt-1'>Connect via WhatsApp</h4>
                                <p className='mb-0 small' style={{ color: THEME.colors.textMuted }}>Start an instant conversation with our operations engineer.</p>
                            </div>
                            <MdChevronRight size={26} style={{ color: hoveredCard === 'whatsapp' ? THEME.colors.primary : THEME.colors.textMuted, transition: 'color 0.3s' }} />
                        </div>

                        {/* Email Connection Card */}
                        <a
                            href='mailto:rasops.info@gmail.com'
                            className='d-flex align-items-center gap-4 p-4 text-decoration-none rounded-4 flex-grow-1'
                            onMouseEnter={() => setHoveredCard('email')}
                            onMouseLeave={() => setHoveredCard(null)}
                            style={{
                                backgroundColor: hoveredCard === 'email' ? customColors.cardBg : `${customColors.cardBg}90`,
                                border: hoveredCard === 'email' ? `1px solid ${THEME.colors.primary}60` : '1px solid rgba(255,255,255,0.05)',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            <div
                                className='p-4 rounded-3 d-flex align-items-center justify-content-center shadow'
                                style={{
                                    backgroundColor: hoveredCard === 'email' ? THEME.colors.primary : `${THEME.colors.primary}12`,
                                    color: hoveredCard === 'email' ? THEME.colors.secondary : THEME.colors.primary,
                                    transition: 'all 0.3s ease'
                                }}
                            >
                                <FiMail size={26} />
                            </div>
                            <div className='flex-grow-1'>
                                <small className='text-uppercase tracking-wider d-block font-weight-bold' style={{ fontSize: '0.75rem', letterSpacing: '1.5px', color: THEME.colors.textMuted }}>Official Channel</small>
                                <h4 className='font-weight-bold text-white mb-1 mt-1'>rasops.info@gmail.com</h4>
                                <p className='mb-0 small' style={{ color: THEME.colors.textMuted }}>Drop us an inquiry for custom implementations or proposals.</p>
                            </div>
                            <MdChevronRight size={26} style={{ color: hoveredCard === 'email' ? THEME.colors.primary : THEME.colors.textMuted, transition: 'color 0.3s' }} />
                        </a>

                        {/* Headquarters Static Card */}
                        <div
                            className='d-flex align-items-center gap-4 p-4 rounded-4 flex-grow-1'
                            style={{
                                backgroundColor: `${customColors.cardBg}60`,
                                border: '1px solid rgba(255,255,255,0.03)'
                            }}
                        >
                            <div
                                className='p-4 rounded-3 d-flex align-items-center justify-content-center shadow'
                                style={{
                                    backgroundColor: `${THEME.colors.primary}12`,
                                    color: THEME.colors.primary,
                                    transition: 'all 0.3s ease'
                                }}
                            >

                                <FiMapPin size={26} />
                            </div>
                            <div>
                                <small className='text-uppercase tracking-wider d-block font-weight-bold' style={{ fontSize: '0.75rem', letterSpacing: '1.5px', color: THEME.colors.textMuted }}>Corporate Headquarters</small>
                                <h5 className='text-white font-weight-medium mb-0 mt-1' style={{ opacity: 0.85 }}>Pune, Maharashtra, India</h5>
                            </div>
                        </div>

                    </Col>

                </Row>
            </Container>
        </div>
    );
}
